export default "/imgs/tag/2022.svg"